import { render, staticRenderFns } from "./modelParameter.vue?vue&type=template&id=29d53f70&scoped=true"
import script from "./modelParameter.vue?vue&type=script&lang=js"
export * from "./modelParameter.vue?vue&type=script&lang=js"
import style0 from "./modelParameter.vue?vue&type=style&index=0&id=29d53f70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d53f70",
  null
  
)

export default component.exports